import component from '.';
import { DEFAULT_EDITORS_FIT_DATA_ORDER } from "../../../../lib/utils/consts";

/** @type {UICore.ComponentMeta} */
const TextInputComponentMeta = {
  id: 'textInput',
  name: '文本框',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-textarea_1636365583966.png',
  category: '编辑框',
  component,
  bindings: [{
    id: 'v-model',
    main: true,
    required: true,
    prop: 'value',
    event: 'change',
    checkData: s => s.type === 'string'
  }],
  isFormEditor: true,
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'value',
      type: 'string'
    }, {
      id: 'readonly',
      type: 'boolean',
      title: '只读'
    }, {
      id: 'required',
      type: 'boolean',
      title: '必填'
    }, {
      id: 'password',
      type: 'boolean',
      title: '密码'
    }, {
      id: 'multipleLine',
      type: 'boolean',
      title: '多行输入'
    }, {
      id: 'placeholder',
      type: 'string'
    }]
  },
  events: [{
    id: 'change',
    name: '修改',
    desc: '输入内容变化时。 `$event` 为新的内容',
    arguments: [{
      type: 'string',
      description: '修改后的值'
    }]
  }],
  fitData({
    dataSchema,
    dataPath
  }) {
    if (dataSchema.type !== 'string') return null;
    return {
      type: 'editor',
      order: DEFAULT_EDITORS_FIT_DATA_ORDER,
      layouts: [{
        preview: 'https://vfiles.gtimg.cn/wuji_material/hji4eglfmcl.png',
        title: '单行',
        layout: {
          type: 'textInput',
          bindings: {
            'v-model': dataPath
          }
        }
      }, {
        preview: 'https://vfiles.gtimg.cn/wuji_material/zbnr84p50wf.png',
        title: '多行',
        layout: {
          type: 'textInput',
          bindings: {
            'v-model': dataPath
          },
          props: {
            multipleLine: true
          }
        }
      }],
      layout: {
        type: 'textInput',
        bindings: {
          'v-model': dataPath
        }
      }
    };
  }
};
export default TextInputComponentMeta;